import ReactDOM from "react-dom";
import React from "react";

function importBuildEnvironment() {
    if (process.env.REACT_APP_ENVIRONMENT === "admin") {
        return import("./RootAdminPanel");
    } else if (process.env.REACT_APP_ENVIRONMENT === "scheduler") {
        return import("./RootScheduler");
    } else {
        return Promise.reject(
            new Error("No such build target: " + process.env.REACT_APP_ENVIRONMENT)
        );
    }
}

importBuildEnvironment().then(({default: Environment}) => {
    ReactDOM.render(
        <React.StrictMode>
            <Environment/>
        </React.StrictMode>,
        document.getElementById("root")
    )
})
